import { generatePath } from 'react-router-dom';

import {
  FOOTBALL_PLAY_RIVALS_LEADERBOARD,
  FOOTBALL_PLAY_RIVALS_LEADERBOARD_SEASONSLUG_USERSLUG_SELECTEDUSERSLUG_ARENA,
  FOOTBALL_PLAY_RIVALS_LEADERBOARD_SEASONSLUG_USERSLUG_SELECTEDUSERSLUG_BETWEEN_YOU,
  FOOTBALL_PLAY_RIVALS_LEADERBOARD_SEASONSLUG_USERSLUG_SELECTEDUSERSLUG_MATCHES,
} from '@sorare/core/src/constants/__generated__/routes';
import { useTypedParams } from '@sorare/core/src/lib/routing';

import { ProfileLayout } from 'components/rivals/ProfileLayout';

import { LayoutParams } from './__generated__/routeParams';

const SeasonsLeaderboardSeasonSlugUserSlugSelectedUserSlugLayout = () => {
  const { seasonSlug, userSlug, selectedUserSlug } =
    useTypedParams<LayoutParams>();
  return (
    <ProfileLayout
      selectedUserSlug={selectedUserSlug}
      backPath={FOOTBALL_PLAY_RIVALS_LEADERBOARD}
      arenaPath={generatePath(
        FOOTBALL_PLAY_RIVALS_LEADERBOARD_SEASONSLUG_USERSLUG_SELECTEDUSERSLUG_ARENA,
        {
          seasonSlug,
          userSlug,
          selectedUserSlug,
        }
      )}
      matchesPath={generatePath(
        FOOTBALL_PLAY_RIVALS_LEADERBOARD_SEASONSLUG_USERSLUG_SELECTEDUSERSLUG_MATCHES,
        {
          seasonSlug,
          userSlug,
          selectedUserSlug,
        }
      )}
      betweenYouPath={generatePath(
        FOOTBALL_PLAY_RIVALS_LEADERBOARD_SEASONSLUG_USERSLUG_SELECTEDUSERSLUG_BETWEEN_YOU,
        {
          seasonSlug,
          userSlug,
          selectedUserSlug,
        }
      )}
    />
  );
};
export default SeasonsLeaderboardSeasonSlugUserSlugSelectedUserSlugLayout;
